import { useTranslationsContext } from "../../../helpers/TranslationsContext";
import { analyticsClick } from "../../../helpers/analytics";
import { notNullish } from "../../../helpers/notNullish";
import template from "../../../helpers/template";
import { Prose } from "../../prose/prose";
import { FaqItem } from "./QaSummary.types";
import { CosmosLink, CosmosText } from "@cosmos/web-react";
import classnames from "classnames/bind";
import { useState } from "react";
import { useId } from "react";
import styles from "./QaSummary.module.css";

const cx = classnames.bind(styles);

export const QaSummaryTabs = ({ items }: { items: Array<FaqItem> }) => {
  const [clicked, setClicked] = useState<number | undefined>(0);
  const idQualifier = useId();

  const translations = useTranslationsContext();

  const toggle = (index: number) => {
    if (clicked === index) {
      //if clicked question is already active, then close it
      return setClicked(undefined);
    }

    setClicked(index);
  };

  return (
    <div className={cx("tabs")}>
      <div
        role="tablist"
        aria-labelledby="tablist-1"
        className={cx("tab-buttons")}
      >
        {items.map((item, index) => (
          <button
            key={index}
            id={`tab-${idQualifier}-${index}`}
            type="button"
            role="tab"
            className={cx("question-button")}
            aria-selected={clicked === index ? true : undefined}
            onClick={() => {
              analyticsClick({
                value: items[index].question ?? "",
                clickUrl: `${items[index].url}`,
                elementPosition: "FAQ Section",
                method: "Outbound: FALSE",
                contentType: "FAQ",
              });
              toggle(index);
            }}
            aria-controls={`tabpanel-${idQualifier}-${index}`}
            data-variant="tab"
          >
            {/* 
            DPSPCS-446: Remove the icons from FAQ. To be re-designed in the future. 

            {item.titleGraphic ? (
              <img
                className={cx("graphic")}
                src={getContentfulImageUrl(item.titleGraphic, {
                  width: 80,
                  height: undefined,
                })}
                alt={item.titleGraphicAlt ?? ""}
                aria-hidden={true}
              />
            ) : (
              <CosmosIconInfo className={cx("graphic")} aria-hidden={true} />
            )} */}
            <CosmosText
              className={cx("button-text")}
              size="medium"
              weight="medium"
            >
              {item.question}
            </CosmosText>
          </button>
        ))}
      </div>

      <div className={cx("tab-panels")}>
        {items.filter(notNullish).map((item, index) => (
          <div
            key={index}
            id={`tabpanel-${idQualifier}-${index}`}
            role="tabpanel"
            tabIndex={0}
            className={cx("tab-panel")}
            aria-labelledby={`tab-${idQualifier}-${index}`}
            hidden={clicked === index ? undefined : true}
          >
            <Prose>
              {item.answer}
              {item.url && (
                <CosmosLink
                  className={cx("prose-cta")}
                  kind="underlined"
                  href={item.url}
                >
                  {/* returns empty string (not nullish), use ternary operator */}
                  {template(
                    item.readMoreLabel ||
                      translations["faqSummary.button.seeFullAnswer"],
                    "View full answer",
                  )}
                </CosmosLink>
              )}
            </Prose>
          </div>
        ))}
      </div>
    </div>
  );
};
